import '@mdi/font/css/materialdesignicons.css' 
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import 'vuetify/src/styles/main.sass';
import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify);

export default new Vuetify({
  themes: {
    primary: '#41281b',
    secondary: colors.green.lighten4, 
    accent: colors.indigo.base,
    ts_burntorange: '#f29400',
    ts_redorange: '#e7511e',
    ts_brown: '#41281b',
    text: {
      default: colors.green.lighten4,
      secondary: '#929292',
      white: '#FFFFFF'
    },
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107'    
  },  
  icons: {
    iconfont: 'mdi',
  },
});
